// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEO_DESCRIPTION_FORUM = "M\u00edsto pro tv\u00e9 ot\u00e1zky, zku\u0161enosti i ka\u017edodenn\u00ed radosti a starosti. Zapoj se do diskuz\u00ed o v\u0161em, co \u017eivot p\u0159in\u00e1\u0161\u00ed.";
export const SEO_TITLE_FORUM = "Diskuze";
export const TAB_FORUMS = "Diskuze";
export const TAB_GROUPS = "Skupiny";
